import * as React from 'react';
import { IRccapReportDetail } from '@nkr/models/index';
import { Alert, Button, Modal, Table } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: IRccapReportDetail
    onYes: () => void,
    onNo: () => void
}

const ConfirmDelete: React.FunctionComponent<IProps> = (props) => {
    const swapNumber = props.data != null ? props.data.swapNumber : '';
    const donorCenter = props.data != null ? props.data.donorCenter : '';
    const recipientCenter = props.data != null ? props.data.recipientCenter : '';

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onNo}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm RCCAP Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='danger'>
                    Please confirm that you want to delete the following RCCAP:
                    <br /><br />
                    <Table condensed>
                        <tbody>
                            <tr>
                                <th>Swap #:</th>
                                <td>{swapNumber}</td>
                            </tr>

                            <tr>
                                <th>Donor Center:</th>
                                <td>{donorCenter}</td>
                            </tr>

                            <tr>
                                <th>Recipient Center:</th>
                                <td>{recipientCenter}</td>
                            </tr>
                        </tbody>
                    </Table>

                    <strong>WARNING! This is not reversible!</strong>
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='danger' onClick={props.onYes}>Yes, Delete</Button>
                <Button bsStyle='primary' onClick={props.onNo}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmDelete;